import { sentry } from './sentry'

export const logger = {
    exception: (err: Error) => {
        sentry.captureException(err)
        console.error(err)
    },
    error: (msg: any) => {
        sentry.captureMessage(msg.toString())
        console.error(msg)
    },
}
